import { cn } from '@/lib/utils'
import LoaderV2 from './LoaderV2'

// Replaces the previous PinwheelLoader with the new LoaderV2
// Keeping the name 'PinwheelLoader' for backward compatibility with imports
export function PinwheelLoader({
  text = null,
  className = '',
  success = false,
  onAnimationComplete = null,
  ...props
}) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="flex flex-col items-center justify-center">
        <div className="scale-50 origin-center">
          <LoaderV2 success={success} onAnimationComplete={onAnimationComplete} />
        </div>
        {text && (
          <span className="mt-2 text-sm text-gray-600 font-medium">
            {text}
          </span>
        )}
      </div>
    </div>
  )
}

export function PageLoader({ text = 'Loading' }) {
  return (
    <PinwheelLoader
      text={text}
      className="min-h-[400px]"
    />
  )
}

export function FullScreenLoader({ text = 'Loading' }) {
  return (
    <div className="fixed inset-0 bg-white/90 flex items-center justify-center z-50">
      <PinwheelLoader text={text} />
    </div>
  )
}
